import React, { memo } from 'react'
import { useModalState } from 'utils/hooks/useModalState'
import CoverModal from 'apps/marketplace/components/CoverModal'
import { isDigitalOption } from 'apps/marketplace/utils/helpers/isDigitalOption'
import AcceptInboundOptionConfirmationModal, {
  IAcceptInboundOptionConfirmationModalProps,
} from '../AcceptInboundOptionConfirmationModal'

export interface IAcceptOptionConfirmationModalProps
  extends IAcceptInboundOptionConfirmationModalProps {}

const AcceptOptionConfirmationModal = memo<IAcceptOptionConfirmationModalProps>(
  ({ onClose, onSuccess, option }) => {
    const { shipmentId, source } = option || {}
    const isDigital = isDigitalOption(source)

    const { modalState } = useModalState({
      acceptInboundModal: isDigital,
      coverageModal: !isDigital,
    })
    const { acceptInboundModal: isAcceptInboundModalOpen, coverageModal: isCoverageModalOpen } =
      modalState || {}

    return (
      <>
        {isAcceptInboundModalOpen && (
          <AcceptInboundOptionConfirmationModal
            option={option}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        )}
        {isCoverageModalOpen && (
          <CoverModal
            shipmentId={shipmentId}
            carrierOption={option}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        )}
      </>
    )
  }
)

export default AcceptOptionConfirmationModal
